export const parseDateString = (date: string) => {
  if (!date) {
    return null;
  }
  if (date.match(/^\d{2}-\d{2}-\d{4}$/)) {
    return date.split('-').reverse().join('-');
  }
  return date.replace(/^(\d{2})(\d{2})(\d{4})$/, '$3-$2-$1');
};
